/**
 * Polyfill for expo-font
 * For web, we don't need to load fonts via expo-font since Next.js handles font loading
 * This provides a no-op implementation
 */

export const loadAsync = async () => {
  // For web, fonts should be loaded via CSS @font-face or Next.js font optimization
  // This is a no-op that resolves immediately
  return Promise.resolve()
}

export const isLoaded = () => {
  // Assume fonts are loaded via CSS
  return true
}

export const isLoading = () => {
  return false
}

export default {
  loadAsync,
  isLoaded,
  isLoading,
}
